import { useState } from 'react'
import { getHours, getMinutes, isBefore, isSameDay, startOfDay } from 'date-fns'
import { DatePicker } from 'rsuite'
import 'rsuite/DatePicker/styles/index.css'
import s from './styles.module.scss'

export const DateInput = ({
  value,
  onClick,
  text,
  onChange,
}: {
  value?: Date | null
  onChange?: (val: Date | null) => void
  onClick?: () => void
  text?: string
}) => {
  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false)
  const shouldDisableDate = (date: Date) => {
    const todayStart = startOfDay(new Date())
    return isBefore(date, todayStart)
  }
  const shouldDisableHour = (hour: number, date: Date) => {
    const now = new Date()
    if (!isSameDay(date, now)) return false

    const currentHour = getHours(now)

    return hour < currentHour
  }
  const shouldDisableMinute = (minute: number, date: Date) => {
    const now = new Date()
    if (!isSameDay(date, now)) return false

    const nowHour = getHours(now)
    const nowMinute = getMinutes(now)
    const dateHour = getHours(date)
    const dateMinute = getMinutes(date)

    if (dateHour !== nowHour || dateMinute !== nowMinute) return false

    return minute < nowMinute
  }
  return (
    <>
      {!value && (
        <span
          className={s.date}
          onClick={() => {
            onClick?.()
            setIsOpenDatePicker(true)
          }}
        >
          {text}
        </span>
      )}
      {value && (
        <DatePicker
          cleanable
          format="dd/MM/yyyy HH:mm"
          open={isOpenDatePicker}
          onClose={() => {
            setIsOpenDatePicker(false)
          }}
          shouldDisableDate={shouldDisableDate}
          shouldDisableHour={shouldDisableHour}
          shouldDisableMinute={shouldDisableMinute}
          appearance="subtle"
          value={value}
          onChange={onChange}
        />
      )}
    </>
  )
}
